<style lang="scss">
    .discounts-modal {
        .modal-content-wrapper {
            max-width: 1000px;
            margin: auto;
        }
        .packages {
            .discounts-title {
                margin-top: 0;
            }
            .discounts-description {
                margin-bottom: 50px;
            }
        }
        @media (max-width: 767px) {
            .packages {
                .discounts-title {
                    font-size: 26px !important;
                }
            }
        }
    }
</style>

<template>

	<div class="discounts-modal modal fade" id="discountsModal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="modal-content-wrapper">
                    <div class="row item-list item-list-sm item-list-by m-b">
                        <div class="col-xs-12">
                            <discount-row v-if="haveDiscounts.length" :prices="haveDiscounts"></discount-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import Configure from './../../mixins/configure'
    import DiscountRow from './../packagediscounts.vue'
    
    export default {
		components: {
            DiscountRow
		},
		mixins: [Configure],
		computed:{
			haveDiscounts(){
                return _.filter(this.licenses, license => (license.discounts.length && license.enabled === true && license.discountsEnabled));
            }
		},
        data() {
            return {
                licenses: this.$store.state.user.licenses
            }
        }
    }
</script>